
import React from 'react';
import OptimizedFadeIn from '../OptimizedFadeIn';
import WaitlistForm from './WaitlistForm';
import { useWaitlist } from '../../context/WaitlistContext';

const WaitlistSection: React.FC = () => {
  const { email, setEmail, handleWaitlistSubmit } = useWaitlist();
  
  return (
    <section 
      id="waitlist-form" 
      className="bg-white py-16"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto bg-[#F9F5F0] rounded-3xl p-8 shadow-sm">
          <OptimizedFadeIn>
            <h3 className="text-2xl font-display font-semibold text-hormony-charcoal mb-4 text-center">
              Join the Waitlist
            </h3>
            <p className="text-hormony-charcoal/70 mb-6 text-center">
              Limited spots available. Sign up to be notified when we open registration.
            </p>
            
            <WaitlistForm
              email={email}
              setEmail={setEmail}
              handleWaitlistSubmit={handleWaitlistSubmit}
              buttonText="Join the Waitlist"
              className="w-full"
            />
          </OptimizedFadeIn>
        </div>
      </div>
    </section>
  );
};

export default React.memo(WaitlistSection);
